import { createStore } from 'vuex';

export default createStore({
  state: {
    codeParam: '',
    nameParam: '',
    vidParam: '',
  },
  mutations: {
    SET_CODE_NAME_VID_PARAM(state, payload) {
      state.codeParam = payload.code;
      state.nameParam = payload.name;
      state.vidParam = payload.vid;
    },
  },
  actions: {
  },
  modules: {
  },
});
